import { useEffect, useState } from 'react'
import { usePage } from '@inertiajs/react'

// Toast for Rails flash messages — auto-dismisses so it never blocks the gallery.
export default function Flash() {
  const { flash } = usePage().props
  const message = flash?.notice || flash?.alert
  const isAlert = Boolean(flash?.alert)
  const [visible, setVisible] = useState(Boolean(message))

  useEffect(() => {
    setVisible(Boolean(message))
    if (!message) return

    const timer = setTimeout(() => setVisible(false), 4500)
    return () => clearTimeout(timer)
  }, [message])

  if (!message || !visible) return null

  return (
    <div className="pointer-events-none fixed inset-x-0 top-4 z-50 flex justify-center px-4">
      <div
        role="status"
        className={`animate-pop-in pointer-events-auto flex items-center gap-3 rounded-full border-2 px-5 py-3 font-display font-bold shadow-lg ${
          isAlert
            ? 'border-rose-200 bg-rose-50 text-rose-700'
            : 'border-emerald-200 bg-emerald-50 text-emerald-800'
        }`}
      >
        <span aria-hidden="true">{isAlert ? '🙈' : '🎉'}</span>
        <span>{message}</span>
        <button
          type="button"
          onClick={() => setVisible(false)}
          className="ml-1 cursor-pointer text-lg leading-none opacity-50 hover:opacity-100"
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  )
}
